export default __webpack_public_path__ + "static/Card8-8fbf23051abf2ef78f687b18bd4dadfb.png";